import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito equipo de gimnasio?',
  a: 'No, es 100% estilo de vida y nutrición.'
}, {
  q: '¿Es seguro para mayores de 50?',
  a: 'Es ideal, es donde más resultados se ven.'
}, {
  q: '¿Cuándo recibo el producto?',
  a: 'Acceso digital inmediato tras el pago en Hotmart.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-brand-darker border-y border-brand-gray" data-id="element-40">
      <div className="max-w-3xl mx-auto" data-id="element-41">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-42">
          <h2 className="text-3xl md:text-5xl font-bold text-white uppercase" data-id="element-43">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-44">
          {faqs.map((faq, idx) => <motion.div key={idx} className="bg-brand-dark border border-brand-gray rounded-lg overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} data-id="element-45">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-46">
                <span className="text-lg font-bold text-white uppercase tracking-wide" data-id="element-47">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-orange transition-transform ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-48" />
              </button>
              <AnimatePresence data-id="element-49">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="px-6 pb-6 text-brand-muted text-lg" data-id="element-50">
                    {faq.a}
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}